import { QuestionType } from "@/types";

const getQuestionTypeLabel = (type: QuestionType) => {
  switch (type) {
    case QuestionType.MultipleChoice:
      return "Multiple Choice";
    case QuestionType.TrueFalse:
      return "True/False";
    case QuestionType.ShortAnswer:
      return "Short Answer";
  }
  return "Unknown";
};

export default getQuestionTypeLabel;
